const actions = {
  SUBMIT_FILE: 'SUBMIT_FILE',
  DELETE_FILE: 'DELETE_FILE',
  DELETE_SUCCESS: 'DELETE_SUCESS',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  GET_FILELIST_BY_WORKORDERID: 'GET_FILELIST_BY_WORKORDERID',
  GET_FILELIST_BY_ASSET: 'GET_FILELIST_BY_ASSET',
  GET_FILELIST_REDUCER: 'GET_FILELIST_REDUCER',
  GET_FILELIST_BY_PURCHASE_ORDER: 'GET_FILELIST_BY_PURCHASE_ORDER',
  GET_FILELIST_BY_CREDIT_CARD: 'GET_FILELIST_BY_CREDIT_CARD',
  GET_FILELIST_BY_RRQ: 'GET_FILELIST_BY_RRQ',
  GET_FILELIST_BY_DRILL: 'GET_FILELIST_BY_DRILL',
  GET_FILELIST_BY_SCHEDULE_DRILL: 'GET_FILELIST_BY_SCHEDULE_DRILL',
  // initData: () => ({ type: actions.GET_PROJECTS }),
  submitFile: (sendData, config) => {
    return (dispatch, getState) => {
      dispatch({
        type: actions.SUBMIT_FILE,
        payload: { sendData: sendData, config: config },
      });
    };
  },
  getFiles: (workOrderId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FILELIST_BY_WORKORDERID,
        payload: { id: workOrderId },
      });
    };
  },
  getFilesByAsset: (assetId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FILELIST_BY_ASSET,
        payload: { id: assetId },
      });
    };
  },
  getFilesByPurchaseOrder: (purchaseOrderId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FILELIST_BY_PURCHASE_ORDER,
        payload: { id: purchaseOrderId },
      });
    };
  },
  getFilesByCreditCard: (creditCardId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FILELIST_BY_CREDIT_CARD,
        payload: { id: creditCardId },
      });
    };
  },
  getFilesByRfq: (rfqId) => {
    return (dispatch) => {
      dispatch({ 
        type: actions.GET_FILELIST_BY_RRQ, 
        payload: { id: rfqId } 
      });
    };
  },
  getFilesByDrill: (drillId) => {
    return (dispatch) => {
      dispatch({ 
        type: actions.GET_FILELIST_BY_DRILL, 
        payload: { id: drillId } 
      });
    };
  },
  getFilesByScheduleDrill: (drillId) => {
    return (dispatch) => {
      dispatch({ 
        type: actions.GET_FILELIST_BY_SCHEDULE_DRILL, 
        payload: { id: drillId } 
      });
    };
  },
  deleteFile: (selected) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_FILE,
        payload: {id:selected}
      });
    };
  },
  // updateData: (sendData, id) => {
  //   return (dispatch) => {
  //     dispatch({
  //       type: actions.UPDATE_PROJECT,
  //       payload: { sendData: sendData, id: id },
  //     });
  //   };
  // },
};
export default actions;
